import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/sys/speechTypeTemplate/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/sys/speechTypeTemplate/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/sys/speechTypeTemplate/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/sys/speechTypeTemplate/submit',
    method: 'post',
    data: row
  })
}
